export const shadows = {
  lg: "0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814",
  sm: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
  xs: "0px 1px 2px 0px #1018280D",
};
